import React from "react";
import { joinClassnames, mapMultiClassnames } from "utils/map-modifier";
import "./index.scss";

export interface CheckboxButtonProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  iconActive?: string;
  iconNoneActive?: string;
  iconLarge?: boolean;
  iconXLarge?: boolean;
  className?: string;
}

export const CheckboxButton: React.FC<CheckboxButtonProps> = ({
  label,
  iconActive,
  iconNoneActive,
  iconLarge,
  iconXLarge,
  className,
  ...innerProps
}) => (
  <div
    className={joinClassnames(
      innerProps.disabled && "a-checkboxbutton-disabled",
      className,
    )}
  >
    <label className="a-checkboxbutton_label">
      <input
        {...innerProps}
        className="a-checkboxbutton_input"
        type="checkbox"
      />
      <div className="a-checkboxbutton_content">
        {iconActive && iconNoneActive && (
          <div
            className={mapMultiClassnames(
              "a-checkboxbutton_toggleicon",
              iconLarge && "large",
              iconXLarge && "xlarge",
            )}
          >
            <span
              className="a-checkboxbutton_toggleicon-icon"
              style={{
                background: `url(${iconNoneActive}) center center/contain no-repeat`,
              }}
            />
            <span
              className="a-checkboxbutton_toggleicon-icon"
              style={{
                background: `url(${iconActive}) center center/contain no-repeat`,
              }}
            />
          </div>
        )}
        <span>{label}</span>
      </div>
    </label>
  </div>
);
